import { Link } from "@components/index";
import { LINKS } from "@components/Link/Link";
import TypographyV2 from "@components/TypographyV2/TypographyV2";
import React from "react";
import * as styles from "./ColumnsTemplate.module.scss";
import { NavbarTopic } from "./Products";

type Props = {
	columns: NavbarTopic[];
};

const ColumnsTemplate = ({ columns }: Props) => {
	return (
		<div
			style={{
				display: "grid",
				gridTemplateColumns: `repeat(3, 1fr)`,
			}}
		>
			{columns.map(({ title, topics }) => {
				return (
					<div className={styles.column}>
						<TypographyV2 className={styles.title} weight="MEDIUM">
							{title}
						</TypographyV2>
						{topics?.map(({ title: name, icon, to }, index) => {
							return (
								<Link
									key={index}
									to={LINKS[to || "LANDING"].to}
								>
									<div className={styles.row}>
										{icon}
										<TypographyV2
											variant="BODY_TEXT_MEDIUM"
											weight="MEDIUM"
											color="gray-700"
										>
											{name}
										</TypographyV2>
									</div>
								</Link>
							);
						})}
					</div>
				);
			})}
		</div>
	);
};

export default ColumnsTemplate;
